/**
 * @flow
 * @relayHash 3060d6f1584ff44f758016ff37d11111
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FooterRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FooterRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Footer_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": "dibs-buyer-layout/191.2.14-2018-10-30T15:17:02.390Z/FooterRefetchQuery",
  "kind": "Batch",
  "metadata": {},
  "name": "FooterRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "FooterRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isTradeExperienceEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "TRADE_EXPERIENCE",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"TRADE_EXPERIENCE\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isSellerDirectoryEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SELLER_DIRECTORY",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"SELLER_DIRECTORY\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isSellerApplicationEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SELLER_APPLICATION",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"SELLER_APPLICATION\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isAboutUsPageEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ABOUT_US_PAGE",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"ABOUT_US_PAGE\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isCareersPageEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CAREERS_PAGE",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"CAREERS_PAGE\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isPressPageEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "PRESS_PAGE",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"PRESS_PAGE\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isSiteMapsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "HTML_SITE_MAPS",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"HTML_SITE_MAPS\"}"
          },
          {
            "kind": "ScalarField",
            "alias": "isDownloadAppEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DOWNLOAD_APP",
                "type": "String!"
              }
            ],
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale{\"featureName\":\"DOWNLOAD_APP\"}"
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currencies",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
